// @flow
import React from "react";
import { useSelector } from "react-redux";

import SelecaoRadioBaseComTraducao from "../../../comum/SelecaoRadioBaseComTraducao";
import {
  selecionarPeriodicidade,
  getPeriodicidadeSelecionada,
  getPeriodicidades,
  getIsPeriodoInicioOuFinalDaSerieSelecionado,
  getIsPeriodoNoDiaSelecionado,
  getPeriodosSelecionados,
} from "../../../../state";

import { useEdicaoDeMedida } from "../../Contexto";

import {
  PERIODOS_SEMANAIS,
  ID_PERIODO_DATAS_ESPECIFICAS_MODO_SERIES,
} from "../../../../model/constantes";

export default function SelecaoPeriodicidade() {
  const { exibirSelecaoPeriodicidade } = useEdicaoDeMedida();

  const periodoId = useSelector(getPeriodosSelecionados);

  const isPeriodoInicioOuFinalDeSerieSelecionado: ?boolean = useSelector(
    getIsPeriodoInicioOuFinalDaSerieSelecionado
  );
  const isPeriodoNoDiaSelecionado: ?boolean = useSelector(
    getIsPeriodoNoDiaSelecionado
  );

  if (!exibirSelecaoPeriodicidade) {
    return null;
  }

  if (isPeriodoInicioOuFinalDeSerieSelecionado || isPeriodoNoDiaSelecionado) {
    return null;
  }

  return (
    <div className="ConfiguracaoMedida">
      <SelecaoRadioBaseComTraducao
        chaveTraducaoNomeSelecao={"Periodicidade.Descricao"}
        itensSelector={getPeriodicidades}
        selectorItemSelecionado={getPeriodicidadeSelecionada}
        onItemChange={selecionarPeriodicidade}
        campoId="id"
        campoChaveTraducao="chaveTraducao"
        periodoId={periodoId}
        periodos={PERIODOS_SEMANAIS}
        periodoDefault={ID_PERIODO_DATAS_ESPECIFICAS_MODO_SERIES}
      />
    </div>
  );
}
